var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header15'),_c('router-view'),_c('UtilsBar'),_c('Footer15')],1)}
var staticRenderFns = []

export { render, staticRenderFns }